import moment from 'moment'
import * as d3 from 'd3'

export default {
  methods: {

    draw_Timeline() {    

      this.Chart_Area = this.svg
      .append('g')
      .attr('id', 'SCREEN')
      .attr('transform', `translate(${this.canvas.padding.left+.5}, ${this.canvas.padding.top+.5})`)
      .attr('font-family', 'roboto') // rage / roboto

      let Timeline = this.Chart_Area
      .append('g')
      .attr('transform', `translate(0, ${this.canvas.chart.height+.5})`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      Timeline
      .append('line')
      .attr('x1', 0).attr('y1', -.5).attr('x2', this.canvas.chart.width).attr('y2', -.5)
      .attr('stroke', '#bcbcbc').attr('storke-width', .3)

      Timeline
      .append('g')
      .selectAll('path')
      .data(this.timeline.week) // *** week
      .enter()
      .append('path')
      .attr('d', (d, i) => {
        if (i != this.timeline.week.length-1) return `M${this.timeline.scale(d.eDate)+ 1}, 0 V 3` // *** week
      })
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      // cutoff Week highlight
      let cutoff = moment(this.timeline.cutoff).format('YYYY-MM-DD')

      this.timeline.week.forEach(d => {
        if (moment(d.eDate).format('YYYY-MM-DD') == cutoff) {
          Timeline
          .append('rect')
          .attr('x',this.timeline.scale(d.sDate) + 1)
          .attr('y',.5)
          .attr('width', this.timeline.scale(d.eDate) - this.timeline.scale(d.sDate))
          .attr('height',5)
          .style('opacity', 0.3)
          .attr('fill','#F35E90')
          .attr('stroke','#bcbcbc')
          .attr('stroke-width',0.5)               
        }
      })
      
      // Month Text
      Timeline
      .append('g')
      .selectAll('text')
      .data(this.timeline.month) // *** week
      .enter()
      .append('text')
      .attr('x', d => this.timeline.scale(d.mDate)).attr('y', 6 + 9*0.75)
      .style('font-size', 9).attr('fill', '#757575')
      .attr('text-anchor', 'middle')
      .text(d => d.name)

      Timeline
      .append('g')
      .selectAll('path')
      .data(this.timeline.month) // *** week
      .enter()
      .append('path')
      .attr('d', (d, i) => {
        if (i != this.timeline.month.length-1) return `M${this.timeline.scale(d.eDate)+ 1}, 0 V 14` // *** week
      })
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      // Year Text & Timeline Seperator for the Year
      Timeline
      .append('g')
      .selectAll('text')
      .data(this.timeline.year)
      .enter()
      .append('text')
      .attr('x', d => this.timeline.scale(d.mDate))
      .attr('y', 20 + 10*0.75)
      .style('font-size', 10).attr('fill', '#333')
      .attr('text-anchor', 'middle')
      .text(d => d.name)

      Timeline
      .append('g')
      .selectAll('path')
      .data(this.timeline.year)
      .enter()
      .append('path')
      .attr('d', (d, i) => {
        if (i != this.timeline.year.length-1) return `M${this.timeline.scale(d.eDate) + 1}, 0 V 28`
      })
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
    }, 

    draw_Grid() {
      let sGrid = this.Chart_Area
      .append('g')
      .attr('transform', `translate(0, 0)`)
      
      this.grid.forEach((d,i)=> {
        sGrid
        .append('line')
        .attr('x1', 0).attr('x2', this.canvas.chart.width)
        .attr('y1', d).attr('y2', d)
        .attr('stroke', '#bcbcbc')
        .attr('stroke-width', .5)
        .attr('opacity', .3)
      })
    },

    draw_Axis_Primary() {

      let maxPrimary = 100

      this.scale.Primary = d3.scaleLinear()
      .domain([0, 100])
      .range([this.canvas.chart.height, 0])

      this.grid.forEach((d,i)=> {
        this.Chart_Area
        .append('line')
        .attr('x1', - 5)
        .attr('x2', 0)
        .attr('y1', d)
        .attr('y2', d)
        .attr('stroke', '#bcbcbc')
        .attr('stroke-width', .5)

        this.Chart_Area
        .append('text')
        .attr('id', `Axis_Primary_${i}`)
        .attr('transform', `translate(${-7}, ${d + 1 + 9*0.26})`)
        .attr('font-size', 9)
        .attr('fill', '#757575')
        .attr('text-anchor', 'end')
        .text(`${(maxPrimary) * (i*2)/10}%`)
      })

      this.Chart_Area
      .append('line')
      .attr('x1', 0).attr('y1', 0)
      .attr('x2', 0).attr('y2', this.canvas.chart.height)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      this.Chart_Area
      .append('line')
      .attr('x1', this.canvas.chart.width).attr('y1', 0)
      .attr('x2', this.canvas.chart.width).attr('y2', this.canvas.chart.height)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      this.Chart_Area
      .append('text')
      .attr('transform', `translate(${-45 + 12*0.26}, ${this.canvas.chart.height/2}) rotate(-90)`)
      .attr('font-size', 12).attr('fill', '#333')
      .attr('text-anchor', 'middle')
      .text('Cumulative Progress(%)')
    },

    
  }
}